// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Ix","pending":"e_Jx","slider":"e_Kx","imageContainer":"e_Lx","image":"e_Mx","button":"e_Nx","prevButton":"e_Ox","nextButton":"e_Px","disabled":"e_Qx"};